import Repository from '@/repositories/marketing'
const resource = '/sms_campaigns'

export default {
  fetch (config) {
    return Repository.get(`${resource}.json`, config)
  },
  delete (id) {
    return Repository.delete(`${resource}/${id}.json`)
  },
  show (id) {
    return Repository.get(`${resource}/${id}.json`)
  },
  export(id,payload){
   return Repository.get(`${resource}/${id}/export.json`,payload)
  },
  create (data, config) {
    return Repository.post(`${resource}.json`, data, config)
  },
  update (campId, data, config) {
    return Repository.put(`${resource}/${campId}.json`, data, config)
  },
  /**
   * Fetches clicks overview data 
   * @param {string} accountId of the account whose camapign sms clicks  are to be fetched
   *  */ 
  fetchClickOverview(id,config){
    return Repository.get(`${resource}/${id}/sms_urls.json`, config)
  },
  /**
   * Fetches detailed report data 
   * @param {string} accountId of the account whose camapign sms click  are to be fetched
   *  */ 
  fetchDetailedReport(id,config){
    return Repository.get(`${resource}/${id}/sms_campaign_clicks.json`, config)
  },
  /**
   * api's used in transaction SMS campaigns
   */
  fetchSMSCampaigns(config){
    return Repository.get(`${resource}.json?filter_by=trans`,config)
  },
  fetchItemCount(id){
    return Repository.get(`${resource}/${id}/sms_campaign_analytics.json?`)
  }
}
